// NPM Imports
import React, { Component } from "react";
import amplitude from "amplitude-js";

// Components Imports
import { PageLoader } from "../../../commonComponents";

// Actions Import
import { authenticateUser } from "../../../actions/AuthActions/authActions";

// Methods Imports
import { getRedirectUrlPostSignout } from "../../../actions/AuthActions/authMethods";

// Internals Imports
import {
  DEFAULT_AUTH_REDIRECTION_URL,
  SIGNUP_ONBOARD_CHECKLIST,
} from "../../../constants/auth";
import { GlobalUtils, AmplitudeUtils } from "../../../utils";

// Destructuring
const { readCookie, removeCookie, writeDataToLocalStorage } = GlobalUtils;

class AuthenticateUser extends Component {
  state = { showLoader: false };

  componentDidMount() {
    this._amplitudeInitCall();
    this._onFirstAppLoad();
    this._authenticateUser();
  }

  _amplitudeInitCall = () => {
    const amplitudeDataJson = readCookie("amplitudeData");
    const amplitudeData = amplitudeDataJson
      ? JSON.parse(amplitudeDataJson)
      : null;
    if (amplitudeData) {
      removeCookie("amplitudeData");
      const {
        event: { eventName, eventData },
        userProperties,
        type,
      } = amplitudeData;
      if (
        type === "NORMAL_SIGNUP" ||
        type === "INVITE_SIGNUP" ||
        type === "SIGNIN"
      ) {
        if (
          amplitudeData.event &&
          amplitudeData.event.eventData &&
          amplitudeData.event.eventData.anonymous_user_id !== "None"
        ) {
          try {
            amplitude
              .getInstance()
              .setDeviceId(amplitudeData.event.eventData.anonymous_user_id);
          } catch (err) {
            console.error(
              `reset user id on Load/Init => src/index.js => ${err}`,
            );
          }
        }

        try {
          AmplitudeUtils.amplitudeInit(userProperties);
        } catch (err) {
          console.error(
            `AmplitudeInit Error => AuthenticateUser => amplitudeInit => ${err}`,
          );
        }
      }
      try {
        AmplitudeUtils.amplitudeLogEvent(eventName, {
          ...eventData,
        });
      } catch (err) {
        console.error(
          `AmplitudeInit Error => AuthenticateUser => amplitudeLogEvent => ${err}`,
        );
      }
    }
  };

  // METHOD THAT TRIGGERES AFTER USER SIGNS_UP AND LAND INTO THE APP FOR THE FIRST TIME
  _onFirstAppLoad = () => {
    if (this.props.user.redirectedFromSignup) {
      writeDataToLocalStorage("displayCreateDocPopUP", true);
      writeDataToLocalStorage("isFirstLogin", true);
      writeDataToLocalStorage("onBoardCheckList", SIGNUP_ONBOARD_CHECKLIST);
    }
  };

  _authenticateUser = () => {
    this.setState({ showLoader: true });
    authenticateUser(this.props.user)
      .then(() => {
        removeCookie("checkAuth");
        const fromUrl =
          readCookie("fromUrl") || `${DEFAULT_AUTH_REDIRECTION_URL}`;
        removeCookie("fromUrl");
        this.props.history.push(fromUrl);
      })
      .catch(error => {
        this.setState({ showLoader: false });
        console.error(`AuthenticateUser => authenticateUser => ${error}`);
        removeCookie("user");
        removeCookie("fromUrl");
        removeCookie("checkAuth");
        window.location.href = getRedirectUrlPostSignout();
      });
  };

  render() {
    return (
      <div className="pipeline-page">
        {this.state.showLoader ? (
          <PageLoader
            leftSecTotalList={20}
            rightSecTotoalList={20}
            showTopSec
            showLeftSec
            showRightSec
            isFullPage
            page="ASSETS"
          />
        ) : null}
      </div>
    );
  }
}

export default AuthenticateUser;



// WEBPACK FOOTER //
// ./src/components/AuthComponents/AuthenticateUser/index.js